import React from 'react';
import {translate} from 'react-i18next';
import Modal from './Modal';
import MapView from '../MapView';
import TagChooser from '../TagChooser';

class EmbedModal extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = {

            bounds: null,
            shown: false,
            tags: [],
        };

        this.focusRef = React.createRef();
        this.mapContainerRef = React.createRef();
        this.mapRef = null; // We need to use a ref callback because the MapView component uses withRouter.

        this.handleBoundsChange = this.handleBoundsChange.bind(this);
        this.handleModalShow = this.handleModalShow.bind(this);
        this.handleTagRemove = this.handleTagRemove.bind(this);
        this.handleTagsAdd = this.handleTagsAdd.bind(this);
    }

    addTags(...tags) {

        this.setState((prevState, props) => {

            const current = [...prevState.tags];

            tags.forEach(tag => {

                if (!current.includes(tag))
                    current.push(tag);
            });

            if (current.length !== prevState.tags.length)
                return {tags: current};
        });
    }

    afterRender() {

        if (this.props.show && this.focusRef.current)
            this.focusRef.current.focus();
    }

    componentDidMount() {

        this.afterRender();
    }

    componentDidUpdate() {

        this.afterRender();
    }

    getCode() {

        const b = this.state.bounds;
        const container = this.mapContainerRef.current;

        if (!b) return; // Let the map initialize first.

        const base = window.location.origin;

        return `<iframe src="${base}/embed/embed.html?tags=${this.state.tags.join(',')}&bounds=${b.toBBoxString()}" height="${container.clientHeight}" width="${container.clientWidth}" frameborder="0"></iframe>`;
    }

    handleBoundsChange(bounds) {

        this.setState({bounds});
    }

    handleModalShow() {

        this.mapRef.map.invalidateSize();
    }

    handleTagRemove(tag) {

        this.removeTag(tag);
    }

    handleTagsAdd(tags) {

        this.addTags(...tags);
    }

    removeTag(tag) {

        this.setState((prevState, props) => {

            const tags = prevState.tags;

            if (tags.includes(tag))
                return {tags: tags.filter(x => x !== tag)};
        });
    }

    render() {

        const {t} = this.props;

        return (

            <Modal show={this.props.show} title={t('modals.embedModal.title')} onClose={this.props.onClose} onShow={this.handleModalShow}>

                <h6 className="mb-3">{t('modals.embedModal.selectTags')}</h6>
                <TagChooser ref={this.focusRef} tags={this.state.tags} className="mb-3" onTagsAdd={this.handleTagsAdd} onTagRemove={this.handleTagRemove}/>
                <p className="small mb-3">{t('modals.embedModal.selectTagsDisclaimer')}</p>

                <h6 className="mb-3">{t('modals.embedModal.selectBounds')}</h6>
                <div ref={this.mapContainerRef} className="mb-3" style={{height: '15rem', width: '100%'}}>

                    <MapView wrappedComponentRef={el => this.mapRef = el}
                             cameraControl={false}
                             onBoundsChange={this.handleBoundsChange}
                             style={{height: '100%', width: '100%'}}/>

                </div>

                <h6 className="mb-3">{t('modals.embedModal.copyCode')}</h6>
                <pre style={{whiteSpace: 'pre-wrap'}}>{this.getCode()}</pre>

            </Modal>
        );
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.show && !prevState.shown) {

            return {

                bounds: nextProps.bounds,
                shown: true,
                tags: [...nextProps.tags],
            };
        }
        else if (!nextProps.show && prevState.shown) {

            return {shown: false};
        }

        return null;
    }
}

EmbedModal.defaultProps = {

    tags: [],
};

export default translate()(EmbedModal);



// WEBPACK FOOTER //
// ./src/components/modals/EmbedModal.js